import useDisplayNames from '../../../shared/hooks/useDisplayNames/useDisplayNames'
import useActivitiesDisplayName from '../../../shared/hooks/useDisplayNames/variants/useActivitiesDisplayName'
import useEvidenceDisplayName from '../../../shared/hooks/useDisplayNames/variants/useEvidenceDisplayName'
import useStrategicImperativeDisplayName from '../../../shared/hooks/useDisplayNames/variants/useStrategicImperativeDisplayName'
import useTppDisplayName from '../../../shared/hooks/useDisplayNames/variants/useTppDisplayName'
import useValueNarrativeDisplayName from '../../../shared/hooks/useDisplayNames/variants/useValueNarrativeDisplayName'
import { ValueMessageDisplayNames } from './ValueMessageTable.types'

export const useValueMessageDisplayNames = (): ValueMessageDisplayNames => ({
    valueNarrative: useValueNarrativeDisplayName().singular,
    evidence: useEvidenceDisplayName().plural,
    evidenceGaps: useDisplayNames().getDisplayName('evidenceGaps', 'Evidence Gaps'),
    activities: useActivitiesDisplayName().plural,
    strategicImperatives: useStrategicImperativeDisplayName().plural,
    tpp: useTppDisplayName().singular,
})
